import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { nanoid } from '@reduxjs/toolkit';
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from '@material-ui/core';

import {
  setNutritionistTestCurrentStep,
  setNutritionistTestTarget,
} from 'features/nutritionists/state/nutritionist-test.slice';
import { nutritionistTestOptionsSelector } from 'features/nutritionists/selectors/nutritionist-test.selector';

import { useGetNutritionistsService } from 'features/nutritionists/services/get-nutritionists.service';

import { useStyles } from './nutritionist-search-test-step-1-form.styles';

export const NutritionistSearchTestStep1Form = () => {
  const [questionKey, setQuestionKey] = useState('');
  const [questionValue, setQuestionValue] = useState('');

  const { step1: questionOptions } = useSelector(
    nutritionistTestOptionsSelector,
  );

  const questionValues = useMemo(() => {
    if (questionKey) {
      const questionValues = questionOptions.find(
        option => option.key === questionKey,
      );
      return questionValues ? questionValues.childOptions : [];
    }
    return [];
  }, [questionKey, questionOptions]);

  const getNutritionistsService = useGetNutritionistsService();

  const dispatch = useDispatch();

  const classes = useStyles();

  // TODO: Crear función reutilizable para los demás pasos.
  const generateQueryParams = data => {
    const { specialFilter, childOptions } = data;

    if (specialFilter) {
      const queryParams = `?specialFilter=${specialFilter}`;
      return { queryParams };
    }

    if (!specialFilter) {
      const queryParams = childOptions.reduce(
        (accumulator, option, index, array) => {
          const key = 'keySpecialities';
          let queryString = accumulator + key + '=' + option;
          if (index !== array.length - 1) {
            queryString = queryString + '&';
          }
          return queryString;
        },
        '?',
      );

      return { queryParams };
    }
  };

  const onRadioChangeHandler = event => {
    const { value: stepKey } = event.target;
    setQuestionKey(stepKey);
    setQuestionValue('');
  };

  const onSelectChangeHandler = event => {
    const { value: stepValue } = event.target;
    setQuestionValue(stepValue);
  };

  const onNextStepHandler = () => {
    const target = questionValues.find(option => option.key === questionValue);

    if (target) {
      const { nextStep } = target;

      if (nextStep === 5) {
        const payload = generateQueryParams(target);
        getNutritionistsService.mutate(payload, {
          onSuccess: () => {
            dispatch(setNutritionistTestCurrentStep(nextStep - 1));
          },
        });
      } else {
        dispatch(setNutritionistTestTarget(target));
        dispatch(setNutritionistTestCurrentStep(nextStep - 1));
      }
    }
  };

  useEffect(() => {
    const { key = '' } = questionOptions[0] || {};
    setQuestionKey(key);
  }, [questionOptions]);

  return (
    <Box component="section" className={classes.stack}>
      <Typography variant="h6">¿Para quién buscas un nutriólogo?</Typography>
      <RadioGroup value={questionKey} onChange={onRadioChangeHandler}>
        {questionOptions.map(option => (
          <FormControlLabel
            key={nanoid()}
            value={option.key}
            label={option.option}
            control={<Radio color="primary" />}
          />
        ))}
      </RadioGroup>
      <FormControl style={{ width: '33%' }} variant="outlined">
        <InputLabel>Selecciona una opción</InputLabel>
        <Select
          label="Selecciona una opción"
          value={questionValue}
          onChange={onSelectChangeHandler}
        >
          {questionValues.map(option => (
            <MenuItem key={nanoid()} value={option.key}>
              {option.option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Box className={classes.buttonsWrapper}>
        <Button disabled variant="outlined" color="primary">
          Anterior
        </Button>
        <Button
          variant="outlined"
          color="primary"
          onClick={onNextStepHandler}
          disabled={
            !questionKey || !questionValue || getNutritionistsService.isLoading
          }
        >
          {getNutritionistsService.isLoading ? 'Buscando...' : 'Siguiente'}
        </Button>
      </Box>
    </Box>
  );
};
